import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'

import EditorsContent from './EditorsContent'
export default class Editors extends Component {

   

    render() {
        let page = this.props.match.params.page;
        return (
            <div class="wrapper">

                <Navbar />
                <Mainmenu />
                <EditorsContent page={page} />
                <Footer />

            </div>


        )
    }
}
